import { Controller } from 'stimulus';

class ModalController extends Controller {
  connect() {
    const $modal = $(this.element);

    if ($modal && $modal.get(0).hasAttribute('data-open-initially')) {
      $modal.modal('show');
    }
  }
}

ModalController.targets = [
  //
];

export default ModalController;
